import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  OutlinedInput,
  TextField,
  Typography,
  NoSsr
} from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import clsx from 'clsx'
import { Trans } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Router, { useRouter } from 'next/router'
import { useAuth } from '../components/context/useFetch'
import Layout from '../components/layout'
import { useUpdate, useAlert } from '../components/reducer'

import AuthService from '../components/auth/auth_service'
import allPagesProps from '../components/common/all_pages_props'

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '5% auto'
  },
  margin: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  textField: {
    width: '100%'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

const CustomPasswordField = ({ state, setState, label, labelWidth }) => {
  const [showPassword, setShowPassword] = useState(false)
  const classes = useStyles()
  return (
    <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
      <InputLabel htmlFor="outlined-adornment-password">{label}</InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        type={showPassword ? 'text' : 'password'}
        value={state}
        onChange={(e) => setState(e.target.value)}
        inputProps={{
          minLength: 8
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(!showPassword)} onMouseDown={(e) => e.preventDefault()} edge="end" tabindex="-1">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        labelWidth={labelWidth}
        required
      />
    </FormControl>
  )
}

const SetPassword = () => {
  const classes = useStyles()

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const alert = useAlert()

  const auth = useAuth()

  const formSubmitHandler = (e) => {
    e.preventDefault()
    if (password === confirmPassword) {
      auth
        .fetch('profile', {
          method: 'PUT',
          body: {
            user_attributes: {
              id: auth.getToken().id,
              password,
              password_confirmation: confirmPassword
            }
          }
        })
        .then((res) => Router.push('/'))
        .then((res) => alert('notice', <Trans i18nKey="alerts.confirmed_account" />))
        .catch((error) => {
          alert('error', <Trans i18nKey="alerts.error" />)
        })
    }
  }

  return (
    <Container className={classes.container} maxWidth="md">
      <form onSubmit={formSubmitHandler}>
        <Card style={{ paddingTop: '20px', marginBottom: '40px' }}>
          <CardContent>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <Grid item>
                <Typography variant="h6" style={{ paddingBottom: '20px' }}>
                  <Trans i18nKey="set_password.title" />
                </Typography>
              </Grid>
              <Grid item>
                <CustomPasswordField state={password} setState={setPassword} label={<Trans i18nKey="set_password.password" />} labelWidth={100} />
              </Grid>
              <Grid item>
                <CustomPasswordField state={confirmPassword} setState={setConfirmPassword} label={<Trans i18nKey="set_password.confirm_password" />} labelWidth={220} />
              </Grid>
              <Grid item>
                {(password.length > 0 && password !== confirmPassword) && (
                  <Typography variant="body2" style={{ color: 'red', fontSize: '12px' }}>
                    <Trans i18nKey="set_password.alert" />
                  </Typography>
                )}
              </Grid>
            </Grid>
          </CardContent>
          <CardActions className={classes.buttons}>
            <Button variant="contained" color="primary" name="submit" type="submit" size="large">
              <Trans i18nKey="set_password.validate" />
            </Button>
          </CardActions>
        </Card>
      </form>
    </Container>
  )
}

export const LogWithQueryParam = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false)

  const router = useRouter()

  useEffect(() => {
    if (Object.keys(router.query).length === 0) {
      return
    }

    const auth = new AuthService()

    auth.loginWithOmniauth({
      ...router.query,
      auth_token: router.query['access-token'],
      client_id: router.query.client_id
    })
    auth.updateSelf().then(() => {
      setLoggedIn(true)
    })

    if (!children) {
      location.href = '/'
    }
  }, [router.query])

  if (!loggedIn) {
    return null
  }

  return children || null
}

export default () => (
  <NoSsr>
    <LogWithQueryParam>
      <Layout pageTitle="pages_titles.set_password">
        <SetPassword />
      </Layout>
    </LogWithQueryParam>
  </NoSsr>
)

export const getServerSideProps = async (context) => ({ props: await allPagesProps(context) })
